<div class="foa-holder">
  <foa-header></foa-header>

  <div class="foa-content-holder">
    <router-outlet></router-outlet>
  </div>

  <foa-footer></foa-footer>
</div>
